import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetCenterById,
	adminGetAllCenters,
	resetFocusCenter,
	initNewCenter,
	adminPatchCenter,
	adminPostCenter,
	adminDeleteCenter,
	adminImportCenters,
	getCentersMyRdv,
} from "services/center";
import { adminGetAllBoxes } from "services/box";
import { adminGetAllScanners } from "services/scanner";
import { refreshCenterScans, removeScanOrdo } from "services/prescription";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/Centers/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";
import ScansCenter from "components/Others/ScansCenter";
import PaymentForm from "./Forms/PaymentForm";
import DepositForm from "./Forms/DepositForm";

const schemaValidation = Yup.object().shape({
	name: Yup.string().required("Champ requis"),
	abbreviation: Yup.string().required("Champ requis"),
	isCenter: Yup.boolean().required("Champ requis"),
	requireTypeDomicile: Yup.boolean().required("Champ requis"),
	usedForDeposit: Yup.boolean().required("Champ requis"),
	numSeqNotRequiredForDeposit: Yup.boolean().required("Champ requis"),
	showAllCatalog: Yup.boolean().required("Champ requis"),
	isTvSecActivated: Yup.boolean().required("Champ requis"),
	availableForExternalSamplers: Yup.boolean().required("Champ requis"),
	tvSecToSenior: Yup.boolean().required("Champ requis"),
	aliquotLevel: Yup.string().required("Champ requis"),
	expressAvailable: Yup.boolean().required("Champ requis"),
});

class CentersAdmin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			aliquotLevelSelectList: [
				{ key: 0, text: "Gestion des aliquots < 2h", value: "MINUS2" },
				{ key: 0, text: "Gestion des aliquots < 4h", value: "MINUS4" },
				{ key: 0, text: "Gestion des aliquots < 6h", value: "MINUS6" },
				{ key: 0, text: "Gestion des aliquots < 8h", value: "MINUS8" },
				{ key: 0, text: "Pas de gestion des aliquots", value: "NOALIQUOT" },
			],
			boxFactory: {
				list: this.props.boxes.list.data.map((i) => {
					return { ...i, code: `${i.name}` };
				}),
				selected: [],
				listLabel: "Liste des boxes disponibles",
				selectedLabel: "Boxes dans ce centre",
				tmp: {
					add: [],
					remove: [],
				},
			},
			scannerFactory: {
				list: this.props.scanners.list.data.map((i) => {
					return { ...i, code: `${i.name}` };
				}),
				selected: [],
				listLabel: "Liste des scanners disponibles",
				selectedLabel: "Scanners dans ce centre",
				tmp: {
					add: [],
					remove: [],
				},
			},
		};
	}
	setupFactories = (elt) => {
		this.setState({
			boxFactory: {
				list: elt
					? this.props.boxes.list.data
							.filter((i) => !i.center || i.center.id === elt.id)
							.map((i) => {
								return { ...i, code: `${i.name}`, persisted: false };
							})
					: [],
				selected:
					elt !== undefined && elt !== null && elt.boxes !== undefined && elt.id
						? elt.boxes
								.filter((i) => i.center && i.center.id === elt.id)
								.map((i) => {
									return { ...i, code: `${i.name} ${i.center ? `- ${i.center.name}` : ""}`, persisted: true };
								})
						: [],
				listLabel: this.state.boxFactory.listLabel,
				selectedLabel: this.state.boxFactory.selectedLabel,
				tmp: this.state.boxFactory.tmp,
			},
			scannerFactory: {
				list: elt
					? this.props.scanners.list.data
							.filter((i) => !i.center || i.center.id === elt.id)
							.map((i) => {
								return { ...i, code: `${i.name}`, persisted: false };
							})
					: [],
				selected:
					elt !== undefined && elt !== null && elt.scanners !== undefined && elt.id
						? elt.scanners
								.filter((i) => i.center && i.center.id === elt.id)
								.map((i) => {
									return { ...i, code: `${i.name} ${i.center ? `- ${i.center.name}` : ""}`, persisted: true };
								})
						: [],
				listLabel: this.state.scannerFactory.listLabel,
				selectedLabel: this.state.scannerFactory.selectedLabel,
				tmp: this.state.scannerFactory.tmp,
			},
		});
	};

	resetFactories = () => {
		this.setState({
			boxFactory: {
				list: this.state.boxFactory.list,
				selected: this.state.boxFactory.selected,
				listLabel: this.state.boxFactory.listLabel,
				selectedLabel: this.state.boxFactory.selectedLabel,
				tmp: {
					add: [],
					remove: [],
				},
			},
			scannerFactory: {
				list: this.state.scannerFactory.list,
				selected: this.state.scannerFactory.selected,
				listLabel: this.state.scannerFactory.listLabel,
				selectedLabel: this.state.scannerFactory.selectedLabel,
				tmp: {
					add: [],
					remove: [],
				},
			},
		});
	};

	componentDidMount() {
		this.getAllElements();
		if (this.props.centers.focus.data !== null) {
			this.setupFactories(this.props.centers.focus.data);
		}
	}

	componentWillUnmount() {
		this.props.resetFocusCenter();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.centers.focus.data !== prevProps.centers.focus.data) {
			this.setupFactories(this.props.centers.focus.data);
		}
	}

	getAllElements = () => {
		this.props.adminGetAllCenters();
		this.props.adminGetAllBoxes();
		this.props.adminGetAllScanners();
		this.props.getCentersMyRdv();
	};

	focusOnElement = (elt) => {
		this.props.adminGetCenterById(elt.id);
		this.props.refreshCenterScans(elt.id, null);
	};

	onAddClick = () => {
		this.props.initNewCenter();
	};

	saveFocus = (values, setSubmitting) => {
		// Handle boxes
		values.boxesTmp = {
			add: this.state.boxFactory.tmp.add.map((i) => i.id),
			remove: this.state.boxFactory.tmp.remove.map((i) => i.id),
		};
		// Handle boxes
		values.scannersTmp = {
			add: this.state.scannerFactory.tmp.add.map((i) => i.id),
			remove: this.state.scannerFactory.tmp.remove.map((i) => i.id),
		};
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostCenter(values).then(() => {
				Promise.all([this.props.adminGetAllScanners(), this.props.adminGetAllBoxes()]).then(() => {
					this.resetFactories();
					setSubmitting(false);
				});
			});
		} else {
			this.props.adminPatchCenter(values).then(() => {
				Promise.all([this.props.adminGetAllScanners(), this.props.adminGetAllBoxes()]).then(() => {
					this.resetFactories();
					setSubmitting(false);
				});
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteCenter(this.props.centers.focus.data.id);
	};

	render() {
		const { centers } = this.props;
		const { focus, list } = centers;
		const center = focus.data;
		const newCenter = center !== null && center.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={centers.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="Centre"
					addButtonText="Nouveau Centre"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.name}
					groupField="isCenter"
					groupFieldTrueName="Ouvert aux patients"
					groupFieldFalseName="Fermé aux patients"
					focusedEltId={center}
				/>

				<ElementFocus element={focus} list={list} entity="Centre" icon="info" importFunction={this.props.adminImportCenters}>
					{center !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: center.id,
								name: center.name || "",
								abbreviation: center.abbreviation || "",
								group: center.group || "",
								isCenter: center.isCenter || false,
								requireTypeDomicile: center.requireTypeDomicile || false,
								usedForDeposit: center.usedForDeposit || false,
								numSeqNotRequiredForDeposit: center.numSeqNotRequiredForDeposit || false,
								cashAvailable: center.cashAvailable || false,
								invoicesAvailable: center.invoicesAvailable || false,
								servipayAvailable: center.servipayAvailable || false,
								sumupAvailable: center.sumupAvailable || false,
								themeHospitalActivated: center.themeHospitalActivated || false,
								showAllCatalog: center.showAllCatalog || false,
								isTvSecActivated: center.isTvSecActivated || false,
								availableForExternalSamplers: center.availableForExternalSamplers || false,
								tvSecToSenior: center.tvSecToSenior || false,
								tel: center.tel || "",
								myrdvId: center.myrdvId || null,
								aliquotLevel: center.aliquotLevel || "NOALIQUOT",
								expressAvailable: center.expressAvailable || false,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusCenter}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newCenter ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newCenter && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm
														boxFactory={this.state.boxFactory}
														scannerFactory={this.state.scannerFactory}
														centersMyrdv={this.props.centers.myRdv}
														aliquotLevelSelectList={this.state.aliquotLevelSelectList}
													/>
												</AdminDataContainer>
												<br />
												<AdminDataContainer ribbonColor="yellow" ribbonLabel="Dépôts">
													<DepositForm />
												</AdminDataContainer>
												<br />
												<AdminDataContainer ribbonColor="orange" ribbonLabel="Moyens de paiements disponibles">
													<PaymentForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row columns={1}>
											<Grid.Column>
												<ScansCenter
													center={center}
													getScansForTVsecretariat={this.props.getScansForTVsecretariat}
													refreshCenterScans={this.props.refreshCenterScans}
													scans={this.props.scans}
													removeScanOrdo={this.props.removeScanOrdo}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		centers: state.admin.centers,
		boxes: state.admin.boxes,
		scanners: state.admin.scanners,
		scans: state.prescriptions.tvSecScans,
	};
};

const mapDispatchToProps = {
	adminGetAllBoxes,
	adminGetAllCenters,
	adminGetCenterById,
	adminPatchCenter,
	adminDeleteCenter,
	resetFocusCenter,
	adminPostCenter,
	initNewCenter,
	adminImportCenters,
	adminGetAllScanners,
	refreshCenterScans,
	removeScanOrdo,
	getCentersMyRdv,
};

export default connect(mapStateToProps, mapDispatchToProps)(CentersAdmin);
